import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO13 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-3.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO13
